import { useMutation } from "react-query";
import axios from "axios";
import Config from "../Config";
import { useNavigate } from "react-router-dom";

export const useVerifyOfflineOtp = (token) => {
    const navigate = useNavigate();
    const verifyOtp = async (payload) => {
        return await axios.post(`${Config.ApiUrl}/tenant/pay/offline/otp/verify`, payload, {
            headers: {
                authorization: `Bearer ${token}`,
                "Content-Type": "application/json",
            },
        });
    };

    const { mutate: verifyOfflinePayment, isLoading: isVerifyingOtp } = useMutation(verifyOtp, {
        onSuccess: (response) => {
            navigate("/payment-success");
        },
        onError: (error) => {
        },
    });

    return {
        verifyOfflinePayment,
        isVerifyingOtp,
    };
};